import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/subtopicthree/pointsActv1topic3.glb";

export class PointsActvOne extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.circle_yogbreak = gltf.scene.getObjectByName("circle_yogbreak", true);
			this.circle_yoglalafre_pla = gltf.scene.getObjectByName("circle_yoglalafre_pla", true);
			this.circle_lalafresa = gltf.scene.getObjectByName("circle_lalafresa", true);
			this.circle_yoplaitnuezfresa = gltf.scene.getObjectByName("circle_yoplaitnuezfresa", true);
			this.circle_licuadofresaplatano = gltf.scene.getObjectByName("circle_licuadofresaplatano", true);
			this.circle_activia_ciruela = gltf.scene.getObjectByName("circle_activia_ciruela", true);
			this.circle_danonefresa = gltf.scene.getObjectByName("circle_danonefresa", true);
			this.visible = false;

			this.positionAllObj = {
				circle_yogbreak: this.circle_yogbreak.position.clone(),
				circle_yoglalafre_pla: this.circle_yoglalafre_pla.position.clone(),
				circle_lalafresa: this.circle_lalafresa.position.clone(),
				circle_yoplaitnuezfresa: this.circle_yoplaitnuezfresa.position.clone(),
				circle_licuadofresaplatano: this.circle_licuadofresaplatano.position.clone(),
				circle_activia_ciruela: this.circle_activia_ciruela.position.clone(),
				circle_danonefresa: this.circle_danonefresa.position.clone(),
			}
		});
	}

	positionAll() {
		Object.entries(this.positionAllObj).forEach(([key, value]) => {
			this[key].position.copy(value)
		})
	}

	getobjectsInteractions() {
		return [
			this.circle_yogbreak,
			this.circle_yoglalafre_pla,
			this.circle_lalafresa,
			this.circle_yoplaitnuezfresa,
			this.circle_licuadofresaplatano,
			this.circle_activia_ciruela,
			this.circle_danonefresa,
		];
	}
	defaultStatus() {
		this.circle_yogbreak.position.y -= 50;
		this.circle_yoglalafre_pla.position.y -= 50;
		this.circle_lalafresa.position.y -= 50;
		this.circle_yoplaitnuezfresa.position.y -= 50;
		this.circle_licuadofresaplatano.position.y -= 50;
		this.circle_activia_ciruela.position.y -= 50;
		this.circle_danonefresa.position.y -= 50;
	}

	renderAnimations() { }
}
